// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__y_Xiz","author":"Table_author__2kGLN","authorImage":"Table_authorImage__sS8rf","unreadRow":"Table_unreadRow__1GzIj"};